import { isNil } from 'lodash';
import { StyleProp, ViewStyle } from 'react-native';
import { MBTextBody1 } from '@shared/components/typography';
import { SubformField } from '@shared/data/entity/fields/SubformField';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: SubformField;
  style: StyleProp<ViewStyle>;
}

const subformStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function SubformCollectionViewField({ field, style }: Props) {
  const { workflowTemplate: queriedWorkflowTemplate } = useWorkflowTemplate(
    isNil(field.workflowTemplate) ? field?.subform.workflowTemplateId : null,
  );
  const workflowTemplate = queriedWorkflowTemplate ?? field.workflowTemplate;

  if (isNil(workflowTemplate) || field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[subformStyles, style]}>
      <MBTextBody1>{workflowTemplate.name}</MBTextBody1>
    </CardCollectionViewFieldContainer>
  );
}
